<template>
  <div>
    <div class="mb-4">
      <h2 class="text-base sm:text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Top Accounts
      </h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Beheer de lijst met Top Accounts. Deze organisaties worden gemarkeerd en komen bovenaan in
        de concretiseren pagina. Per bedrijf kunnen meerdere organization ID's worden toegevoegd.
      </p>
    </div>

    <!-- Add Form -->
    <Top20AddForm class="mb-6" @submit="handleAddTop20Account" />

    <!-- Loading state -->
    <div v-if="isLoadingTop20" class="text-center py-12">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
      <p class="mt-4 text-gray-600 dark:text-gray-400">Laden...</p>
    </div>

    <!-- Error state -->
    <div
      v-else-if="top20Error"
      class="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
    >
      <p class="text-red-800 dark:text-red-300">
        Fout bij laden van Top Accounts: {{ top20Error.message }}
      </p>
    </div>

    <!-- Top 20 Table -->
    <Top20Table v-else :accounts="top20Accounts || []" @delete="confirmDeleteTop20" />

    <!-- Top 20 Delete Modal -->
    <Top20DeleteModal
      :open="showTop20DeleteModal"
      :account="top20ToDelete"
      :is-deleting="isDeletingTop20"
      @close="showTop20DeleteModal = false"
      @confirm="handleDeleteTop20"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useTop20Accounts } from '@/composables/data/useTop20Accounts'

import Top20Table from '@/components/admin/Top20Management/Top20Table.vue'
import Top20AddForm from '@/components/admin/Top20Management/Top20AddForm.vue'
import Top20DeleteModal from '@/components/admin/Top20Management/Top20DeleteModal.vue'

const {
  accounts: top20Accounts,
  isLoading: isLoadingTop20,
  error: top20Error,
  addAccount,
  deleteAccount
} = useTop20Accounts()

const showTop20DeleteModal = ref(false)
const top20ToDelete = ref(null)
const isDeletingTop20 = ref(false)

const handleAddTop20Account = async formData => {
  try {
    await addAccount(formData)
  } catch (err) {
    throw err // Let the form component handle the error
  }
}

const confirmDeleteTop20 = account => {
  top20ToDelete.value = account
  showTop20DeleteModal.value = true
}

const handleDeleteTop20 = async () => {
  if (!top20ToDelete.value) return

  isDeletingTop20.value = true
  try {
    await deleteAccount(top20ToDelete.value.id)
    showTop20DeleteModal.value = false
    top20ToDelete.value = null
  } catch (err) {
    console.error('Error deleting Top Account:', err)
    alert('Fout bij verwijderen van Top Account')
  } finally {
    isDeletingTop20.value = false
  }
}
</script>
